import React from 'react';
import { Link } from 'react-router-dom';
import styles from './GamesLanding.module.css';

const GamesLanding = () => {
    return (
        <div className={styles.container}>
            <Link to="/" className={styles.backLink}>← BACK TO HOME</Link>
            <h1 className={styles.title}>Choose Your Game</h1>
            <div className={styles.grid}>
                <Link to="/motion-clicker" className={styles.card}>
                    <h3 className={styles.cardTitle}>Motion Clicker</h3>
                    <p className={styles.cardDesc}>
                        Click moving targets with precision. Account for motion and speed to hit each mark.
                    </p>
                </Link>
                <Link to="/rotating-star" className={styles.card}>
                    <h3 className={styles.cardTitle}>Rotating Star</h3>
                    <p className={styles.cardDesc}>
                        Physics-based rotating game. Click the nodes to remove them and unbalance the star.
                    </p>
                </Link>
                <Link to="/click-speed" className={styles.card}>
                    <h3 className={styles.cardTitle}>Click Speed</h3>
                    <p className={styles.cardDesc}>
                        Test your reaction time and accuracy. Click the zones to score points as fast as possible.
                    </p>
                </Link>
                <Link to="/momentum-spinner" className={styles.card}>
                    <h3 className={styles.cardTitle}>Momentum Spinner</h3>
                    <p className={styles.cardDesc}>
                        Build momentum to flip the target. Adjust node sizes and click force to customize your challenge.
                    </p>
                </Link>
                <Link to="/shrinking-target" className={styles.card}>
                    <h3 className={styles.cardTitle}>Shrinking Target</h3>
                    <p className={styles.cardDesc}>
                        Race against time as targets shrink. Compete for the fastest reaction in 2-player versus mode.
                    </p>
                </Link>
                <Link to="/click-6" className={styles.card} style={{ borderColor: '#2ecc71' }}>
                    <h3 className={styles.cardTitle} style={{ color: '#2ecc71' }}>Click 6</h3>
                    <p className={styles.cardDesc}>
                        Speed test! Click 6 targets as fast as possible in Grid or Random layout.
                    </p>
                </Link>
                <Link to="/test-latency" className={styles.card} style={{ borderColor: '#f1c40f' }}>
                    <h3 className={styles.cardTitle} style={{ color: '#f1c40f' }}>Latency Calibrator</h3>
                    <p className={styles.cardDesc}>
                        Utility: Measure the input lag of your laser clicker device compared to a mouse. Save the result to apply to all games.
                    </p>
                </Link>
                <Link to="/unicorn-run" className={styles.card} style={{ borderColor: '#e91e63' }}>
                    <h3 className={styles.cardTitle} style={{ color: '#e91e63' }}>Unicorn Run</h3>
                    <p className={styles.cardDesc}>
                        Reaction Shooter: Defend the running unicorn from bats and goblins! Click them before they hit you!
                    </p>
                </Link>
                <Link to="/asteroid-defense" className={styles.card} style={{ borderColor: '#7f8c8d' }}>
                    <h3 className={styles.cardTitle} style={{ color: '#bdc3c7' }}>Asteroid Defense</h3>
                    <p className={styles.cardDesc}>
                        Turret Defense: Protect the ground from falling asteroids! Use Green (Left Click) for speed and Red (Right Click) for power. Coop ready!
                    </p>
                </Link>
                <Link to="/modern-samurai" className={styles.card} style={{ borderColor: '#c0392b' }}>
                    <h3 className={styles.cardTitle} style={{ color: '#e74c3c' }}>Modern Samurai</h3>
                    <p className={styles.cardDesc}>
                        MSP Standards Trainer: Run the 4 drills (3×2, 7yd draw, Bill Drill, 25yd) and benchmark yourself against black belt par times. Screen-calibrated target sizing.
                    </p>
                </Link>
            </div>
        </div>
    );
};

export default GamesLanding;
